import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Stack } from '@mui/material';

import { DEADLINE_BY, deadlineByOptions } from 'constants/feedbackFramework';
import { API_DATE_FORMAT, formatDate, getTomorrowDate } from 'helper/DateLib';
import { notifyApiError } from 'helper/apiErrorNotification';
import { useDialog } from 'hooks/useDialog';
import { dialogPropsSelector } from 'store/entities/ui/slice';
import { useStartNewRoundMutation } from 'store/entities/feedbackFramework/api';
import { RadioGroup } from 'components/complex/RadioGroup';
import { DatePicker } from 'components/simple';
import { Dialog } from 'components/complex';

const dialogId = 'start_feedback_round_dialog';
const tomorrow = getTomorrowDate();

const styles = {
  dialogVisible: {
    overflow: 'visible',
  },
};

export const StartFeedbackRoundDialog = () => {
  const { closeDialog } = useDialog();
  const { recipientIds, frameworkId, onSuccess } = useSelector(dialogPropsSelector);
  const [deadlineBy, setDeadlineBy] = useState(DEADLINE_BY.RECIPIENT);
  const [deadlineDate, setDeadlineDate] = useState(null);

  const [startNewRound, { isLoading }] = useStartNewRoundMutation();

  const onChangeDeadlineRadio = (updatedDeadlineBy) => {
    setDeadlineBy(updatedDeadlineBy);

    if (updatedDeadlineBy === DEADLINE_BY.ADMIN) {
      setDeadlineDate(tomorrow);

      return;
    }

    setDeadlineDate(null);
  };

  const handleConfirmDate = async () => {
    const data = {
      recipient_ids: recipientIds,
      framework: frameworkId,
      ...(deadlineDate && { feedback_deadline: formatDate(deadlineDate, API_DATE_FORMAT) }),
    };

    try {
      await startNewRound(data).unwrap();
      onSuccess();
      closeDialog();
    } catch (error) {
      notifyApiError(error);
    }
  };

  return (
    <Dialog
      isLoading={isLoading}
      id={dialogId}
      title="Do you want to choose the feedback deadline?"
      confirmLabel="Save & Launch"
      cancelLabel="Cancel"
      onConfirm={handleConfirmDate}
      customStyles={{
        contentStyles: styles.dialogVisible,
        paperStyles: styles.dialogVisible,
      }}
    >
      <Stack spacing={2}>
        <RadioGroup options={deadlineByOptions} onChange={onChangeDeadlineRadio} value={deadlineBy} />

        {!!deadlineDate && (
          <DatePicker
            minDate={tomorrow}
            value={deadlineDate}
            placeholder="dd/mm/yyyy"
            onChange={(value) => setDeadlineDate(value)}
          />
        )}
      </Stack>
    </Dialog>
  );
};
